<script lang="ts" setup>
import type { SelectOptions } from '~~/types/components/default'

const emit = defineEmits(['filter-changed'])
const selectedCategories = ref<SelectOptions[]>([])

const route = useRoute()
const router = useRouter()

const res = await useAsyncStoryblokDatasourceQuery({
  datasource: 'article-categories',
})

const categoryOptions = computed(() => {
  return res.value.data.datasource_entries.map((category) => ({
    label: category.name,
    value: category.value,
  }))
})

onMounted(() => {
  nextTick(() => {
    const queryCategories = route.query?.category as string
    if (queryCategories) {
      console.log('route query', queryCategories.split(','))
      handleSelect(
        categoryOptions.value.filter((cat) =>
          queryCategories.split(',').includes(cat.value)
        )
      )
      handleFilter()
    }
  })
})

const handleFilter = () => {
  let filter = {}
  if (selectedCategories.value.length)
    filter = {
      filter_query: {
        category: {
          any_in_array: selectedCategories.value
            .map((category) => category.value)
            .join(','),
        },
      },
    }
  emit('filter-changed', filter)
  router.push({
    path: route.path,
    ...(selectedCategories.value.length
      ? {
          query: {
            category: selectedCategories.value
              .map((cat) => cat.value)
              .join(','),
          },
        }
      : {}),
  })
}

const handleSelect = (value: SelectOptions[]) => {
  selectedCategories.value = value
}
</script>
<template lang="pug">
div(class="container flex items-center justify-center gap-18 -mt-9 mb-9 md:-mt-48 md:mb-24")
  UiMultiSelect(
    :options="categoryOptions"
    :isMultiple="true"
    :model="selectedCategories"
    placeholder="All Categories"
    @updateModel="handleSelect"
  )
  div
    button(class="button button--theme-blue-dark button--md" @click="handleFilter") Filter
</template>
